import { render, staticRenderFns } from "./CenterMapButton.vue?vue&type=template&id=2ecf987f&lang=pug&"
import script from "./CenterMapButton.vue?vue&type=script&lang=ts&"
export * from "./CenterMapButton.vue?vue&type=script&lang=ts&"
import style0 from "./CenterMapButton.vue?vue&type=style&index=0&id=2ecf987f&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports